<app-grid-list [data]="gridData" [isEditable]="isEditable" (modelChanged)="writeSumText()"></app-grid-list>
<div *ngIf="isSumDisplayed" class="wrapper">
    <label class="sum-label"><b>{{sumText}}</b><b [ngStyle]="{'color':(sumNumber==100)?'green':'red'}">{{sumNumber}}</b></label>
</div>
